const {
  evaluateSource
} = require('../lib/evaluateSource');

/**
  * @function evalute - evaluate sliceBehavior
  */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const value = await evaluateSource(source.value, content, parentContentPath, transientContext, nativeFunctions);
  if (value === undefined) {
    return undefined;
  }
  const fromIndex = await evaluateSource(source.fromIndex, content, parentContentPath, transientContext, nativeFunctions);
  const toIndex = await evaluateSource(source.toIndex, content, parentContentPath, transientContext, nativeFunctions);
  if (fromIndex === undefined && toIndex === undefined) {
    return undefined;
  }
  if (fromIndex === undefined) {
    return value.slice(0, toIndex);
  }
  if (toIndex === undefined) {
    return value.slice(fromIndex);
  }
  return value.slice(fromIndex, toIndex);
};
module.exports = {
  evaluate
};